/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var TargetCrosshairIcon20Light = forwardRef('TargetCrosshairIcon20Light', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 20 }, props),
        React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M2 9.5a7.5 7.5 0 1 1 15 0 7.5 7.5 0 0 1-15 0ZM3.019 9A6.501 6.501 0 0 1 9 3.019V6a.5.5 0 0 0 1 0V3.019A6.501 6.501 0 0 1 15.981 9H13a.5.5 0 0 0 0 1h2.981A6.501 6.501 0 0 1 10 15.981V13a.5.5 0 0 0-1 0v2.981A6.501 6.501 0 0 1 3.019 10H6a.5.5 0 0 0 0-1H3.019Z" })));
});
